"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = exports.apply = void 0;
const procedure_1 = require("../interpreter/procedure");
const listHelpers_1 = require("../utils/listHelpers");
const stringify_1 = require("../utils/stringify");
exports.apply = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'apply',
    callSignature: {
        style: 'var-args',
        numCompulsoryParameters: 1
    },
    body: function* (args, context) {
        const proc = args[0];
        if (proc.type !== 'procedure') {
            throw new Error(`\`apply' expected a procedure as the first argument, got ${proc.type}`);
        }
        let actualArguments;
        if (args.length === 1) {
            // no arguments provided
            actualArguments = [];
        }
        else {
            const lastSuppliedArgument = args[args.length - 1];
            if (lastSuppliedArgument.type !== 'pair' && lastSuppliedArgument.type !== 'empty list') {
                throw new Error(`\`apply' expected a list as the last argument, but got ${lastSuppliedArgument.type}`);
            }
            let tailArgList;
            if (lastSuppliedArgument.type === 'empty list') {
                tailArgList = [];
            }
            else {
                const list = listHelpers_1.flattenPairToList(lastSuppliedArgument);
                if (list.type === 'ImproperList') {
                    throw new Error(`\`apply' expected a list as the last argument, but got an improper list`);
                }
                tailArgList = list.value.map(listElement => listElement.value);
            }
            const spreadArgList = args.slice(1, -1);
            actualArguments = spreadArgList.concat(tailArgList);
        }
        if (procedure_1.isParentInTailContext(context)) {
            return {
                type: 'TailCall',
                procedure: proc,
                args: actualArguments,
                node: context.runtime.nodes[0]
            };
        }
        else {
            return yield* procedure_1.apply(context, proc, actualArguments, context.runtime.nodes[0]);
        }
    }
};
exports.error = {
    type: 'procedure',
    name: 'error',
    callSignature: {
        style: 'var-args',
        numCompulsoryParameters: 1
    },
    variant: 'BuiltInProcedure',
    body: (args) => {
        const output = args.map(value => stringify_1.stringify(value)).join(' ');
        throw new Error(output);
    }
};
//# sourceMappingURL=control.js.map